module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c4fedf6d8022763dafa4432c2fe574aa.gif";